import comp from "./QuestionLoader";
export default comp;
